module.exports = __webpack_public_path__ + "img/icon7.bfd133c8.svg";